// React Query 키 상수 관리
export const QUERY_KEYS = {
  // 찜목록 관련
  WISHLIST: {
    ALL: ['wishlist'] as const,
    PRODUCT_LIST: ['wishlist', 'product', 'list'] as const,
    PRODUCT_LIST_PAGED: (page: number) => ['wishlist', 'product', 'list', 'paged', page] as const,
  },

  // 사용자 관련
  USER: {
    ALL: ['user'] as const,
    PROFILE: ['user', 'profile'] as const,
  },

  // 약국 관련 (예시)
  PHARMACY: {
    ALL: ['pharmacy'] as const,
    LIST: (filters?: any) => ['pharmacy', 'list', filters] as const,
    DETAIL: (id: string) => ['pharmacy', 'detail', id] as const,
  },

  // 의약품 관련 (예시)
  MEDICINE: {
    ALL: ['medicine'] as const,
    SEARCH: (keyword: string) => ['medicine', 'search', keyword] as const,
    DETAIL: (id: string) => ['medicine', 'detail', id] as const,
  },

  CATEGORY: {
    ALL: ['category', 'list'] as const,
  },

  // 제품 관련
  PRODUCT: {
    ALL: ['product'] as const,
    DETAIL: (id: number) => ['product', 'detail', id] as const,
  },

  // 상품문의 관련
  INQUIRY: {
    ALL: ['inquiry'] as const,
    LIST: (page: number, keyword?: string, period?: string) =>
      ['inquiry', 'list', page, keyword || '', period || ''] as const,
  },

  // 자주 구매한 상품 관련
  FREQUENT_PRODUCT: {
    ALL: ['frequent-product'] as const,
    LIST: (page: number, size: number, sortType: string, periodType: string) =>
      ['frequent-product', 'list', page, size, sortType, periodType] as const,
  },

  // 내 병원 전용가 전용관 관련
  HOSPITAL_PRICE: {
    ALL: ['hospital-price'] as const,
    LIST: (
      searchValue: string,
      selectedCategories: string[],
      selectedPrices: string[],
      selectedBrands: string[],
      sortOption: 'POPULARITY' | 'PRICE_ASC' | 'PRICE_DESC' | 'DISCOUNT_DESC' | 'NEWEST' | 'STOCK_DESC' | string,
      currentPage: number,
    ) =>
      [
        'hospital-price',
        'list',
        searchValue,
        selectedCategories,
        selectedPrices,
        selectedBrands,
        sortOption,
        currentPage,
      ] as const,

    SEARCH_FILTER: (subCategoryId: string, keyword?: string, subKeyword?: string) => ['hospital-price', 'search-filter', subCategoryId, keyword, subKeyword] as const,
  },

  // 공지사항 관련
  NOTICE: {
    ALL: ['notice'] as const,
    LIST: (page: number, keyword?: string, type?: 'ALL' | 'NOTICE' | 'UPDATE' | 'EVENT') =>
      ['notice', 'list', page, keyword || '', type || 'ALL'] as const,
  },

  // 인기 검색어 관련
  POPULAR_SEARCH: {
    ALL: ['popular-search'] as const,
  },

  SEARCH: {
    ALL: ['search'] as const,
    SEARCH_FILTER: (subCategoryId: string, keyword?: string, subKeyword?: string) => ['search', 'search-filter', subCategoryId, keyword, subKeyword] as const,
    LIST: (
      keyword: string,
      subKeyword: string,
      selectedCategories: string[],
      selectedPrices: string[],
      selectedBrands: string[],
      sortOption: 'POPULARITY' | 'PRICE_ASC' | 'PRICE_DESC' | 'DISCOUNT_DESC' | 'NEWEST' | 'STOCK_DESC' | string,
      currentPage: number,
      couponEligible?: boolean,
    ) =>
      [
        'search',
        'list',
        keyword,
        subKeyword,
        selectedCategories,
        selectedPrices,
        selectedBrands,
        sortOption,
        currentPage,
        couponEligible,
      ] as const,
  },

  // 장바구니 관련
  CART: {
    ALL: ['cart'] as const,
    LIST: ['cart', 'list'] as const,
    PRICE: ['cart', 'price'] as const,
    COUNT: ['cart', 'count'] as const,
  },

  // 쿠폰 관련
  COUPON: {
    ALL: ['coupon'] as const,
    LIST: ['coupon', 'list'] as const,
  },

  // 주문 관련
  ORDER: {
    ALL: ['order'] as const,
    DETAIL: (id: number) => ['order', 'detail', id] as const,
    // 마이페이지 > 주문/배송조회
    LIST: (page: number, keyword?: string, startDate?: string, endDate?: string) =>
      ['order', 'list', page, keyword || '', startDate || '', endDate || ''] as const,
    SHIPPING_PROPERTIES: ['order', 'shipping-properties'] as const,
  },

  // 취소/반품/교환 관련
  CANCELLED: {
    ALL: ['cancelled'] as const,
    LIST: (page: number, keyword?: string, startDate?: string, endDate?: string) =>
      ['cancelled', 'list', page, keyword || '', startDate || '', endDate || ''] as const,
  },

  // 가격협상 관련
  PRICE_NEGOTIATION: {
    ALL: ['price-negotiation'] as const,
    LIST: (keyword?: string, sortType?: string, page?: number, size?: number) =>
      ['price-negotiation', 'list', keyword || '', sortType || '', page || 0, size || 20] as const,
    DETAIL: (id: number) => ['price-negotiation', 'detail', id] as const,
    PRODUCT_INFO: (productId: number) => ['price-negotiation', 'product-info', productId] as const,
    RE_NEGOTIATION_POPUP: (id: number) => ['price-negotiation', 're-negotiation-popup', id] as const,
  },
  LAYOUT: {
    FOOTER_INFO: ['layout', 'footer-info'] as const,
  },

  // 팝업 관련
  POPUP: {
    ALL: ['popup'] as const,
  },

  // 배너 관련
  BANNER: {
    ALL: ['banner'] as const,
    MAIN: ['banner', 'main'] as const,
    BAR: ['banner', 'bar'] as const,
    SEARCH: ['banner', 'search'] as const,
    PROMOTION: (categoryId: number) => ['banner', 'promotion', categoryId] as const,
  },

  // 예치금/포인트 관련
  WALLET: {
    ALL: ['wallet'] as const,
    LIST: (page: number, size: number, type?: string, startDate?: string, endDate?: string) =>
      ['wallet', 'list', page, size, type || '', startDate || '', endDate || ''] as const,
    ORDER_BALANCE: ['wallet', 'order-balance'] as const,
    WIDGET_KEY: ['wallet', 'widget', 'key'] as const,
  },

  // 결제 관련
  PAYMENT: {
    BANKS: ['payment', 'banks'] as const,
  },

  // 프로모션 관련
  PROMOTION: {
    ALL: ['promotion'] as const,
    MAIN_CATEGORIES: ['promotion', 'main-categories'] as const,
    NEW_MEMBER: ['promotion', 'new-member'] as const,
  },
} as const;
